module.exports = __webpack_public_path__ + "img/H-B-3-load-connect-shadow.216d1dea.png";